<template>
    <div class="recived-account">
        <div class="alarm">
            <span v-if="verifiedState == 1">您必須先通過認證房東，才能新增銀行卡。<router-link :to="{ name: 'MemberCenter'}">認證房東  <img src="@/assets/img/icon/arrow_right_orange.svg" alt=""></router-link></span>
            <span v-if="verifiedState == 2">資料未填</span>
            <span v-if="verifiedState == 3">資料已填但未上傳證件</span>
            <span v-if="verifiedState == 4">房東認證中，審核完成即可新增銀行卡</span>
            <span v-if="verifiedState == 5">已通過認證房東審核，可以新增銀行卡囉</span>
            <span v-if="verifiedState == 6">審查未通過</span>
            <span v-if="verifiedState == 7">帳號停用</span>
        </div>
        <div class="wrap">
            <div class="wallet-tool-bar">
                <div class="filter">
                    <rent-select refName="bankCard" selectMsg="所有狀態" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="isDefault">
                        <ul>
                            <li data-id="NORMAL">審核通過</li>
                            <li data-id="REJECT">審核失敗</li>
                            <li data-id="UNDER_REVIE">審核中</li>
                        </ul>
                    </rent-select>
                </div>
                <div class="stored">
                    <div class="money">
                        <span class="sign">
                            帳戶餘額
                        </span>
                        <div class="number">
                            {{toCurrency(userTotalBalance)}}
                        </div>
                    </div>
                </div>
            </div>
            <new-bank :bankCardState="filter.bankCardState" @clearFilterEvent="clearFilter()"></new-bank>
        </div>

    </div>
</template>
<script>
import RentSelect from '@/components/widge/RentSelect.vue';
import NewBank from '@/components/landlord/houseStatus/memberCenter/memberWallet/NewBank.vue';
import { mapGetters } from 'vuex'
export default {
    data () {
        return{
            isDefault: false,
            filter: {
                bankCardState: null
            }
        }
    },
    methods: {
        getSelectId: function (value) {
            this.isDefault = false
            if( value.ref == 'bankCard' ){
                this.filter.bankCardState = value.id
            }
        },
        // toCurrency: function (num){
        //     var parts = num.toString().split('.');
        //     parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        //     return parts.join('.');
        // },
        clearFilter: function () {
            this.isDefault = true
            this.filter.bankCardState = null
        }
    },
    computed: {
        ...mapGetters({
            verifiedState: 'GET_USER_STATUS',
            userTotalBalance: 'GET_USER_TOTAL_BALANCE',
        })
    },
    components: {
        RentSelect,
        NewBank,
    }
}
</script>
<style lang="scss" scoped>
    .recived-account{
        .alarm {
            border-radius: 0 !important;
            padding: 20px 30px;
        }
        .wrap{
            padding: 20px 30px;
            .wallet-tool-bar{
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 20px;
                .filter{
                    display: flex;
                    .rent-select{
                        width: 75px;
                    }
                }
                .stored{
                    display: flex;
                    .money{
                        position: relative;
                        display: flex;
                        align-items: center;
                        .sign{
                            color: #292625;
                            margin-right: 4px;
                        }
                        .number{
                            color: #ff9275;
                            margin-left: 6px;
                            font-size: 28px;
                        }
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/landlord/houseStatus/memberCenter/memberWallet/recivedAccount.vue